import { queryOptions } from "@tanstack/react-query";

import { listProgramTemplatesFn } from "~/lib/functions/program-template";

export const programTemplateKeys = {
  list: ["program-templates"] as const,
};

export function programTemplatesQueryOptions() {
  return queryOptions({
    queryKey: programTemplateKeys.list,
    queryFn: () => listProgramTemplatesFn(),
  });
}
